export const IconMoneyBack = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Icon of a thumbs up</title>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9764 17.4174C11.8411 16.3542 10.9884 15.8554 9.62154 15.8554L5.13409 15.7969C3.16741 16.0353 3.24327 16.4268 3.07938 18.8111L3 38.5209C3 39.8334 4.15394 40.5449 5.5073 40.5449L9.71949 40.5872C11.0864 40.5872 11.8515 39.6497 12.0139 38.5209C17.832 38.9946 17.3763 41.8313 31.8303 41.9888C36.0528 42.0282 39.0708 42.0544 40.0588 40.4006C40.7626 39.1011 40.3971 37.4998 40.546 36.8304C40.749 35.9116 42.3731 34.9796 42.5896 33.6539C42.7791 32.4989 42.4272 31.5144 42.5355 30.215C42.6708 28.7318 44.6873 26.9204 44.755 25.4634C44.8091 24.1377 44.173 22.707 44.173 21.5782C44.1866 19.8456 45.0392 18.9268 44.9986 18.2312C44.7956 15.2647 42.2242 14.4641 40.0588 14.2672C37.9069 14.0703 30.1386 14.2672 29.2048 14.2672C28.2845 14.2672 27.9732 13.4796 28.3792 12.6921C28.7988 11.8914 32.3987 4.79037 29.3672 1.2858C27.0529 -1.39186 24.2515 0.734514 24.4274 2.07334C24.671 3.79282 23.9131 5.23665 21.9643 7.61241C20.0154 9.98818 16.6185 11.6945 15.3869 15.8554C14.4531 17.7324 12.8426 17.2073 11.9764 17.4174Z"
                fill="#313030"
            />
        </svg>
    );
};
